module.exports = __webpack_public_path__ + "static/media/marisa3.8a021789.mp3";